<section class="cars__cards">
    <div class="cars__cards__content px-md-4 px-2 pb-4">
        <div class="cars__cards__content__container container">
            <div
                class="cars__cards__content__container__title row d-flex align-items-center h-100"
            >
                <h2
                    class="cars__cards__content__container__title__text col py-4 m-0"
                >
                    {{ 'fe_cars_cards_h2_title' | translate }}
                </h2>
                <div class="col py-4 d-flex justify-content-end">
                    <fe-button
                        [style]="'link-tertiary'"
                        [href]="
                            'categorias-y-servicios-adicionales' | formatUrl
                        "
                        ><span
                            class="cars__cards__content__container__title__href align-self-end"
                            >Ver más</span
                        ></fe-button
                    >
                </div>
            </div>
            <div class="cars__cards__content__container__extra row">
                <div
                    *ngFor="let car of getTopCars(cars, 3)"
                    class="cars__cards__content__container__extra__img col-12 col-md-6 col-xl-4 mb-4"
                >
                    <div
                        class="cars__cards__content__container__extra__img__content p-4 flex-fill d-flex flex-column"
                    >
                        <!-- <h3 class="align-self-center">
                            {{ car.title }}
                        </h3> -->
                        <img
                            class="car align-self-center"
                            [src]="car.image"
                            [alt]="car.model"
                        />
                        <h3 class="align-self-center">
                            {{ car.title }}
                        </h3>
                        <div
                            class="d-flex flex-row align-items-center align-self-center"
                        >
                            <img
                                class="svgs"
                                [src]="
                                    car.transmission === 'AT'
                                        ? ('images/icon-trans-aut.svg' | cdn)
                                        : ('images/transmission.svg' | cdn)
                                "
                                alt="transmission"
                            />
                            <p class="ps-2">
                                {{
                                    car.transmission === 'AT'
                                        ? 'Transmisión Automática'
                                        : 'Transmisión Manual'
                                }}
                            </p>
                        </div>
                        <div
                            class="d-flex flex-row align-items-center justify-content-center"
                        >
                            <div
                                class="d-flex flex-row align-items-center align-self-center"
                            >
                                <img
                                    class="svgs"
                                    [src]="'images/icon-seating.svg' | cdn"
                                    alt="passengers quantity"
                                />
                                <p class="px-1">{{ car.passenger }}</p>
                                <div class="mx-2"></div>
                                <img
                                    class="svgs"
                                    [src]="'images/icon-bag.svg' | cdn"
                                    alt="baggage"
                                />
                                <p class="px-1">{{ car.baggage }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
